import { useEffect, useState } from "react";

type Props = {
  websocket: string | null | undefined;
};

const Video = ({ websocket }: Props) => {
  const [html, setHtml] = useState("");

  useEffect(() => {
    const updateHTML = () => {
      setHtml(`<html>

    <head>
        <meta http-equiv="Content-Type" content="text/html; charset=UTF-8;requiresActiveX=true" />
        <meta name="viewport" content="width=device-width, initial-scale=1">
        <title text="VIDEO"></title>
        <style type="text/css">
            html {
                width: 100%;
                height: 100%;
            }
    
            body {
                width: 100%;
                height: 100%;
            }
    
            #notifier {
                position: absolute;
                float: left;
                top: 10%;
                z-index: 2147483647;
                color: #FFF;
                display: none;
            }
        </style>
        <link type="text/css" rel="stylesheet" href="/css/jquery-ui.css" />
    
    </head>
    
    <body style="margin:0px; padding:0px; background-color:#ffffff;">
        <div id="notifier2"></div>
     
        <script>
            var readablestreamname = 'japan_nar_mbr';
            var custname = 'AmWest';
            var platformConf = 'SD';
            var userid = '';
        </script>
        <script>
            function deleteCookies() {
                var allCookies = document.cookie.split(';');
                
                // The "expire" attribute of every cookie is 
                // Set to "Thu, 01 Jan 1970 00:00:00 GMT"
                for (var i = 0; i < allCookies.length; i++)
                    document.cookie = allCookies[i] + "=;expires="
                        + new Date(0).toUTCString();
    
                
    
            }
        </script>
        <script type="text/javascript" src="${process.env.PUBLIC_URL}/js/jquery.min.js"></script>
        <script type="text/javascript" src="${process.env.PUBLIC_URL}/js/jquery-ui.min.js"></script>
        <script type="text/javascript" src="${process.env.PUBLIC_URL}/js/drawfunctions.js"></script>
        <script type="text/javascript" src="${process.env.PUBLIC_URL}/js/NanostreamPlayerInterfaceKris.js"></script>
        <script type="text/javascript" src="${process.env.PUBLIC_URL}/js/rcn-monitor.js"></script>
        <script type="text/javascript" src="${process.env.PUBLIC_URL}/js/Html5Http.js"></script>
        <script type="text/javascript" src="${process.env.PUBLIC_URL}/js/Html5Logging.js"></script>
        <script type="text/javascript" src="${process.env.PUBLIC_URL}/js/Html5Metadata.js"></script>
        <script type="text/javascript" src="${process.env.PUBLIC_URL}/js/Html5Storage.js"></script>
        <script type="text/javascript" src="${process.env.PUBLIC_URL}/js/Html5Time.js"></script>
        <script type="text/javascript" src="${process.env.PUBLIC_URL}/js/Html5Timer.js"></script>
        <script type="text/javascript" src="${process.env.PUBLIC_URL}/js/nanoplayer.min.js"></script>
    
        <script inline="javascript">
            var players = {};
            /*
            startNotify();
            setInterval(function () {
                    startNotify();
            }, 120000);
            */
            const MUTE_STATE = Object.freeze({
                MUTED: 0,
                UNMUTED: 1
            });
    
            var customPlayerSettings = {
                "playButton": {
                    "color": {
                        "r": 255,
                        "g": 255,
                        "b": 255,
                        "opacity": 1
                    }
                },
                "pauseButton": {
                    "left": {
                        "color": {
                            "r": 255,
                            "g": 255,
                            "b": 255,
                            "opacity": 1
                        }
                    },
                    "right": {
                        "color": {
                            "r": 222,
                            "g": 222,
                            "b": 222,
                            "opacity": 1
                        }
                    }
                },
                "muteButton": {
                    "horn": {
                        "fill": {
                            "color": {
                                "r": 255,
                                "g": 255,
                                "b": 255,
                                "opacity": 1
                            }
                        },
                        "stroke": {
                            "color": {
                                "r": 255,
                                "g": 255,
                                "b": 255,
                                "opacity": 1
                            }
                        }
                    },
                    "firstWave": {
                        "stroke": {
                            "color": {
                                "r": 255,
                                "g": 255,
                                "b": 255,
                                "opacity": 1
                            }
                        }
                    },
                    "secondWave": {
                        "stroke": {
                            "color": {
                                "r": 255,
                                "g": 255,
                                "b": 255,
                                "opacity": 1
                            }
                        }
                    }
                },
                "unmuteButton": {
                    "horn": {
                        "fill": {
                            "color": {
                                "r": 255,
                                "g": 255,
                                "b": 255,
                                "opacity": 1
                            }
                        },
                        "stroke": {
                            "color": {
                                "r": 255,
                                "g": 255,
                                "b": 255,
                                "opacity": 1
                            }
                        }
                    },
                    "firstWave": {
                        "stroke": {
                            "color": {
                                "r": 128,
                                "g": 128,
                                "b": 128,
                                "opacity": 1
                            }
                        }
                    },
                    "secondWave": {
                        "stroke": {
                            "color": {
                                "r": 128,
                                "g": 128,
                                "b": 128,
                                "opacity": 1
                            }
                        }
                    }
                },
                "volumeControl": {
                    "background": {
                        "stroke": {
                            "color": {
                                "r": 128,
                                "g": 128,
                                "b": 128,
                                "opacity": 1
                            }
                        },
                        "fill": {
                            "color": {
                                "r": 128,
                                "g": 128,
                                "b": 128,
                                "opacity": 1
                            }
                        }
                    },
                    "currentVolume": {
                        "fill": {
                            "color": {
                                "r": 255,
                                "g": 255,
                                "b": 255,
                                "opacity": 1
                            }
                        }
                    }
                },
                "enterFullscreenControl": {
                    "topLeft": {
                        "style": 1,
                        "color": {
                            "r": 200,
                            "g": 200,
                            "b": 200,
                            "opacity": 1
                        }
                    },
                    "topRight": {
                        "style": 1,
                        "color": {
                            "r": 255,
                            "g": 255,
                            "b": 255,
                            "opacity": 1
                        }
                    },
                    "bottomLeft": {
                        "style": 1,
                        "color": {
                            "r": 255,
                            "g": 255,
                            "b": 255,
                            "opacity": 1
                        }
                    },
                    "bottomRight": {
                        "style": 1,
                        "color": {
                            "r": 200,
                            "g": 200,
                            "b": 200,
                            "opacity": 1
                        }
                    }
                },
                "exitFullscreenControl": {
                    "topLeft": {
                        "style": 2,
                        "color": {
                            "r": 200,
                            "g": 200,
                            "b": 200,
                            "opacity": 1
                        }
                    },
                    "topRight": {
                        "style": 2,
                        "color": {
                            "r": 255,
                            "g": 255,
                            "b": 255,
                            "opacity": 1
                        }
                    },
                    "bottomLeft": {
                        "style": 2,
                        "color": {
                            "r": 255,
                            "g": 255,
                            "b": 255,
                            "opacity": 1
                        }
                    },
                    "bottomRight": {
                        "style": 2,
                        "color": {
                            "r": 200,
                            "g": 200,
                            "b": 200,
                            "opacity": 1
                        }
                    }
                },
                "time": {
                    "color": {
                        "r": 220,
                        "g": 220,
                        "b": 220,
                        "opacity": 1
                    }
                },
                "controlsBackground": {
                    "color": {
                        "r": 64,
                        "g": 64,
                        "b": 64,
                        "opacity": 0.5
                    }
                }
            }
    
            var adaptiveBitrateControl = {
                // How many seconds to wait after a stream has changed before making another change
                "bitrateChangeCooldown": 20, // 15
                "streamStartBitrateCooldown": 15, // 6
                "maxBitrateAttempts": 1,
                "buffer": {
                    // How many seconds to hold a buffer event for
                    "eventHistoryLength": 10,
                    // Amount of buffer events held before failing over to lower bitrate
                    "eventThreshold": 3
                },
                "averageBitrate": {
                    // If average user bitrate falls below this percentage of the stream bitrate, fail over to lower bitrate
                    "percentageThreshold": "65"
                }
            }
    
            // How many buffer events in the history
            var buffer = 0;
            var removeBufferTimeouts = [];
            var currBitrate = 0;
            var streamRecentlyChanged = true;
            var noBufferEvents = 0;
            var changingBitrates = false;
            var usedBitrates = [];
            var lastBitrate = 0;
    
    
            var sources = [];
            sources[1308] = {
    
                "h5live": {
                    "server": {
                        "websocket": "${websocket}",
                    },
                    "rtmp": {
                        "url": "${websocket}",
                        "streamname": "${websocket}"
    
                    },
                    "params": {
                        "h": "",
                        "e": ""
                    }
                }
            };
            var config = {
                events: {
                    onReady: onReady,
                    onPlay: onPlay,
                    onPause: onPause,
                    onLoading: onLoading,
                    onStartBuffering: onStartBuffering,
                    onStopBuffering: onStopBuffering,
                    onError: onError,
                    onStats: onStats,
                    onMetaData: onMetaData,
                    onMute: onMute,
                    onUnmute: onUnmute,
                    onVolumeChange: onVolumeChange,
                    onStreamInfo: onStreamInfo,
                    onWarning: onWarning,
                    onDestroy: onDestroy
                },
                "playback": {
                    "autoplay": ('true' == 'true'),
                    "automute": true,
                    "muted": ('false' == 'true'),
                    "flashplayer": "flash/nano.player.swf",
                    "allowSafariHlsFallback": true
                },
                "style": {
                    "width": 'auto',
                    "scaling": 'fill',
                    "height": 'auto',
                    "controls": ('true' == 'true'),
                    "displayMutedAutoplay": ('true' == 'true')
                },
    
    
            };
    
    
    
            document.addEventListener('DOMContentLoaded', function () {
                setTimeout(function () {
                    streamRecentlyChanged = false;
                },
                    adaptiveBitrateControl.streamStartBitrateCooldown * 1000);
    
                var canPlayNano = false;
                var canPlayFlash = false;
    
                // Create a player ID
                var playerID = "RCNPlayer";
    
                if (typeof NanoPlayer !== 'undefined' && typeof NanoPlayer.capabilities !== 'undefined') {
                    NanoPlayer.capabilities.forEach(function (obj, i) {
                        //
                        if (obj != "flash" && obj != "hls.native") canPlayNano = true;
                        if (obj == "flash") canPlayFlash = true;
                    });
                }
    
                // Create the player with the specified player ID
                $("body").append('<div id="' + playerID + '" style="width:100%;height:100%;overflow:hidden;position:relative"><div id="notifier">45.56.148.57</div></div>');
    
                // If this browser is capable of playing Nano
                if (canPlayNano) {
                    document.onfullscreenchange = onFullScreenChange;
                    document.addEventListener('webkitfullscreenchange', onFullScreenChange);
                    document.addEventListener("mozfullscreenchange", onFullScreenChange);
                    /* Chrome, Safari and Opera */
                    document.addEventListener("webkitfullscreenchange", onFullScreenChange);
                    /* IE / Edge */
                    document.addEventListener("msfullscreenchange", onFullScreenChange);
    
                    var rcnmonitor = new RcnMonitor();
    
                    players[playerID] = new NanoPlayer(playerID);
                    // ConvivaMonitor = new ConvivaMonitor();
    
                    sources.forEach(function (element, index) {
                        if (currBitrate < index) {
                            currBitrate = index;
                        }
                        
                    });
    
                    
    
    
                    config.source = sources[currBitrate];
                    var configarr = {
                        wss_url: config.source.h5live.server.websocket,
                        rtmp_url: config.source.h5live.rtmp.url,
                        rtmp_streamname: config.source.h5live.rtmp.streamname,
                        userid: userid,
                        cust: custname,
                        platform: platformConf
                    }
                    // ConvivaMonitor.init(config, readablestreamname, configarr, false, 0, rcnmonitor);
    
                    //debugger;
                    players[playerID].setup(config).then(function (config) {
                        // Add event to trigger when the bitrate has been switched
                        //$("#" + playerID).on("bitrateswitched", onBitrateSwitch);
                        var setControls = ('true' == 'true');
                        document.getElementById(playerID).addEventListener('bitrateswitched', onBitrateSwitch, false);
                        document.getElementById(playerID).addEventListener('onFullScreenEnter', onFullScreenEnter, false);
                        document.getElementById(playerID).addEventListener('onFullScreenExit', onFullScreenExit, false);
    
                        players[playerID]._core._realPlayer.config.playback.muted === true ? $("div#" + playerID).data({
                            "mute_state": MUTE_STATE.MUTED
                        }) : $("div#" + playerID).data({
                            "mute_state": MUTE_STATE.UNMUTED
                        });
    
                        $("div#" + playerID).data({
                            "volume": 1
                        })
    
                        if (setControls) {
                            drawEnterFullscreenButton(playerID);
                            drawMuteButton(playerID);
                            drawVolume(playerID);
                        }
    
                        setInterval(function () {
                            //startNotify();
                        }, 240000);
                        if (document.getElementById("controls-" + playerID)) {
                            document.getElementById("controls-" + playerID).style.backgroundColor = "rgba(" + customPlayerSettings.controlsBackground.color.r + "," + customPlayerSettings.controlsBackground.color.g + "," + customPlayerSettings.controlsBackground.color.b + "," + customPlayerSettings.controlsBackground.color.opacity + ")";
                        }
    
                    }, function (error) {
                        //alert(error.message);
                    });
    
                } else if (canPlayFlash) {
                    $("#RCNPlayer").append('<div id="resultsplayer2" align="center" style="width: 100%; height: 100%;"><iframe src="//stream.robertsstream.com/streamflash.php?referer=AmWest&stream=japan_nar_mbr&t=1608019704&h=c8529fea3f0f3ddf558e1d599527efce&user=&width=480&height=360&failover=false" width="480" height="360" frameborder="0"  scrolling="no"></iframe></div>');
                } else {
                    $("#RCNPlayer").append("<video id='mobileVideo' style='width: 100%; height: 100%;object-fit: fill;background-color: black;' controls preload='none' playsinline poster='https://replays.robertsstream.com/racereplays/echoplay/includes/play.png' autoplay><source src='//stream.robertsstream.com/streammobile.php?referer=AmWest&stream=japan_nar_mbr&t=1608019704&h=c8529fea3f0f3ddf558e1d599527efce&forceformat=&user=' /></video>");
                }
    
            });
    
            function onFullScreenChange(event) {
                //var element = $(event.target);
    
                if (getFullScreenElement()) {
                    event.target.dispatchEvent(new CustomEvent("onFullScreenEnter", event));
                } else {
                    event.target.dispatchEvent(new CustomEvent("onFullScreenExit", event));
                }
    
            }
    
            function onFullScreenEnter(event) {
                drawMuteButton(event.target.attributes.id.value);
                drawVolume(event.target.attributes.id.value);
                drawPlayPause(event.target.attributes.id.value);
                drawExitFullscreenButton(event.target.attributes.id.value);
    
                setTimeout(drawMuteButton, 100, event.target.attributes.id.value);
                setTimeout(drawVolume, 100, event.target.attributes.id.value);
                setTimeout(drawPlayPause, 100, event.target.attributes.id.value);
                setTimeout(drawExitFullscreenButton, 100, event.target.attributes.id.value);
    
                setTimeout(drawMuteButton, 200, event.target.attributes.id.value);
                setTimeout(drawVolume, 200, event.target.attributes.id.value);
                setTimeout(drawPlayPause, 200, event.target.attributes.id.value);
                setTimeout(drawExitFullscreenButton, 200, event.target.attributes.id.value);
    
                setTimeout(drawMuteButton, 300, event.target.attributes.id.value);
                setTimeout(drawVolume, 300, event.target.attributes.id.value);
                setTimeout(drawPlayPause, 300, event.target.attributes.id.value);
                setTimeout(drawExitFullscreenButton, 300, event.target.attributes.id.value);
            }
    
            function onFullScreenExit(event) {
                drawMuteButton(event.target.attributes.id.value);
                drawVolume(event.target.attributes.id.value);
                drawPlayPause(event.target.attributes.id.value);
                drawEnterFullscreenButton(event.target.attributes.id.value);
    
                setTimeout(drawMuteButton, 100, event.target.attributes.id.value);
                setTimeout(drawVolume, 100, event.target.attributes.id.value);
                setTimeout(drawPlayPause, 100, event.target.attributes.id.value);
                setTimeout(drawEnterFullscreenButton, 100, event.target.attributes.id.value);
    
                setTimeout(drawMuteButton, 200, event.target.attributes.id.value);
                setTimeout(drawVolume, 200, event.target.attributes.id.value);
                setTimeout(drawPlayPause, 200, event.target.attributes.id.value);
                setTimeout(drawEnterFullscreenButton, 200, event.target.attributes.id.value);
    
                setTimeout(drawMuteButton, 300, event.target.attributes.id.value);
                setTimeout(drawVolume, 300, event.target.attributes.id.value);
                setTimeout(drawPlayPause, 300, event.target.attributes.id.value);
                setTimeout(drawEnterFullscreenButton, 300, event.target.attributes.id.value);
            }
    
            function onMetaData(event) {
                
            }
    
            function onStreamInfo(event) {
    
                
            }
    
            function onWarning(event) {
                
            }
    
            function onDestroy(event) {
                
            }
    
            function onError(event) {
                
            }
    
            function onReady(event) {
                
            }
    
            function onStats(event) {
                drawTime(event);
    
                
                
                
    
                // If the buffer threshold has been met, then attempt to lower the bitrate
                if (buffer >= adaptiveBitrateControl.buffer.eventThreshold) {
                    attemptLowerBitrate(event);
                }
    
                if (buffer < 1) {
                    noBufferEvents += 1;
    
                    //
    
                    if (noBufferEvents > 100) {
                        attemptRaiseBitrate(event);
                    }
                } else {
                    noBufferEvents = 0;
                }
    
                //
                //
    
                if (Math.floor(event.data.stats.currentTime) >= 10 && event.data.stats.bitrate.avg / 1024 < currBitrate * (adaptiveBitrateControl.averageBitrate.percentageThreshold / 100)) {
                    //lowerBitrate(event);
                }
    
                deleteCookies();
            }
    
            function attemptLowerBitrate(event) {
                if (!streamRecentlyChanged) {
                    // Initially set the next lower bitrate variable
                    var nextLowerBitrate = 0;
    
                    // Go through sources to check for the next lower bitrate
                    sources.forEach(function (element, index) {
                        if (index < currBitrate && index > nextLowerBitrate) {
                            nextLowerBitrate = index;
                        }
                    });
    
    
                    if (typeof usedBitrates[nextLowerBitrate] === 'undefined' || usedBitrates[nextLowerBitrate] < adaptiveBitrateControl.maxBitrateAttempts) {
                        // Found a lower bitrate available
                        if (currBitrate !== nextLowerBitrate && nextLowerBitrate !== 0 && !changingBitrates) {
                            changingBitrates = true;
                            changeBitrate(event, nextLowerBitrate);
                        }
                    }
                }
            }
    
            function attemptRaiseBitrate(event) {
                if (!streamRecentlyChanged) {
                    // Initially set the next higher bitrate variable
                    var nextHigherBitrate = currBitrate;
    
                    // Go through sources to check for the next higher bitrate
                    sources.forEach(function (element, index) {
                        if (index > currBitrate && (currBitrate === nextHigherBitrate || index < nextHigherBitrate)) {
                            nextHigherBitrate = index;
                        }
                    });
    
                    if (typeof usedBitrates[nextHigherBitrate] === 'undefined' || usedBitrates[nextHigherBitrate] < adaptiveBitrateControl.maxBitrateAttempts) {
                        // Found a higher bitrate available
                        if (currBitrate !== nextHigherBitrate && nextHigherBitrate !== 0 && !changingBitrates) {
                            changingBitrates = true;
                            changeBitrate(event, nextHigherBitrate);
                        }
                    }
                }
            }
    
            function changeBitrate(event, newBitrate) {
                
    
                var options = {
                    method: 'client',
                    pauseOnError: false,
                    forcePlay: true,
                    fastStart: false,
                    timeout: 10,
                }
                //players[event.player].updateSource(sources[newBitrate]).then(function (config) {
                players[event.player].updateSource(sources[newBitrate], options).then(function (config) {
                    // Trigger bitrate switched event
                    var changeBitrateEvent = new CustomEvent('bitrateswitched', {
                        detail: newBitrate
                    });
                    document.getElementById(event.player).dispatchEvent(changeBitrateEvent);
                }, function (error) {
                    
                });
            }
    
            function onPlay(event) {
                drawPlayPause(event.player);
            }
    
            function onPause(event) {
                
                switch (event.data.reason) {
                    case "buffer":
                    case "playbackerror":
                    case "streamnotfound":
                    case "playbackerror":
                    case "notenoughdata":
                        attemptLowerBitrate(event);
                        break;
                }
    
                drawPlayPause(event.player);
            }
    
            function onStartBuffering(event) {
                
                //
                addBufferEvent();
            }
    
            function onStopBuffering(event) {
                
                //
                drawPlayPause(event.player);
            }
    
            function onLoading(event) {
                drawPlayPause(event.player);
            }
    
            function onMute(event) {
                
    
                $("div#" + event.player).data({
                    "mute_state": MUTE_STATE.MUTED
                });
    
                drawMuteButton(event.player);
            }
    
            function onUnmute(event) {
                
                $("div#" + event.player).data({
                    "mute_state": MUTE_STATE.UNMUTED
                });
    
                drawMuteButton(event.player);
            }
    
            function onVolumeChange(event) {
                
    
                $("div#" + event.player).data({
                    "volume": event.data.volume
                });
    
                drawVolume(event.player);
            }
    
            var addBufferEvent = function () {
                buffer++;
                removeBufferTimeouts.push(setTimeout(removeBufferEvent, (adaptiveBitrateControl.buffer.eventHistoryLength * 1000)));
            }
    
            var removeBufferEvent = function () {
                buffer--;
            }
    
            var resetBufferCounts = function () {
                buffer = 0;
                removeBufferTimeouts.forEach(function (element, index) {
                    clearTimeout(element);
                });
    
                removeBufferTimeouts = [];
            }
    
            var onBitrateSwitch = function (event) {
                
                
                
                
                
    
                if (event.detail < currBitrate && event.detail === lastBitrate) {
                    if (typeof usedBitrates[currBitrate] === 'undefined' || usedBitrates[currBitrate] === null)
                        usedBitrates[currBitrate] = 0;
    
                    usedBitrates[currBitrate]++;
                }
    
                lastBitrate = currBitrate;
                currBitrate = event.detail;
                changingBitrates = false;
    
                resetBufferCounts();
                streamRecentlyChanged = true;
    
                
    
                setTimeout(function () {
                    streamRecentlyChanged = false;
                }, adaptiveBitrateControl.bitrateChangeCooldown * 1000);
            }
    
            //Notify
    
            // function startNotify() {
            //     document.getElementById('notifier').style.display = 'block';
            //     document.getElementById('notifier').style.top = Math.floor((Math.random() * 100) + 1) + '%';
            //     setTimeout(function() {
            //         document.getElementById('notifier').style.display = 'none';
            //     }, 5000);
            //     $.ajax({
            //         url: "//stream.robertsstream.com/h2live/iframe/util/authcheck.php",
            //         success: function(result) {
            //             if (result == 0) {
            //                 document.getElementById('RCNPlayer').innerHTML = "";
            //             }
            //         }
            //     });
            // }
        </script>
    
    
        <style>
            #controls-RCNPlayer {
                /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#d60100+0,d69200+16,fefd00+33,00ff00+50,0001ff+67,630082+83,ee82ee+100 */
                /*background: rgb(214,1,0); /* Old browsers */
                /*background: -moz-linear-gradient(left, rgba(214,1,0,1) 0%, rgba(214,146,0,1) 16%, rgba(254,253,0,1) 33%, rgba(0,255,0,1) 50%, rgba(0,1,255,1) 67%, rgba(99,0,130,1) 83%, rgba(238,130,238,1) 100%); /* FF3.6-15 */
                /*background: -webkit-linear-gradient(left, rgba(214,1,0,1) 0%,rgba(214,146,0,1) 16%,rgba(254,253,0,1) 33%,rgba(0,255,0,1) 50%,rgba(0,1,255,1) 67%,rgba(99,0,130,1) 83%,rgba(238,130,238,1) 100%); /* Chrome10-25,Safari5.1-6 */
                /*background: linear-gradient(to right, rgba(214,1,0,1) 0%,rgba(214,146,0,1) 16%,rgba(254,253,0,1) 33%,rgba(0,255,0,1) 50%,rgba(0,1,255,1) 67%,rgba(99,0,130,1) 83%,rgba(238,130,238,1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
                /*filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#d60100', endColorstr='#ee82ee',GradientType=1 ); /* IE6-9 */
            }
    
            div#RCNPlayer div#controls-RCNPlayer canvas#mute-controls-RCNPlayer:hover,
            div#RCNPlayer div#controls-RCNPlayer canvas#playpause-controls-RCNPlayer {
                display: none !important;
            }
    
            ,
            div#RCNPlayer div#controls-RCNPlayer canvas#volume-controls-RCNPlayer:hover,
            div#RCNPlayer div#controls-RCNPlayer canvas#fullscreen-controls-RCNPlayer:hover {
                cursor: pointer;
            }
        </style>
    </body>
    
    </html>`);
    };

    if (websocket) updateHTML();
    else setHtml("");
    return () => {
      console.log("SOCKET DESTROYED");
      setHtml("");
    };
  }, [websocket]);

  return (
    <iframe
      title="Video Stream"
      style={{ minHeight: "250px", border: "none" }}
      height="100%"
      width="100%"
      srcDoc={html}
    ></iframe>
  );
};

export default Video;
